import { CACHE_NAME } from './constants';

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
export const flushCache = () => {
  // try {
  //   const cache = JSON.parse(window.sessionStorage.getItem(CACHE_NAME));
  //   const keys = Object.keys(cache);
  //   for (let i = 0; i < keys.length; i++) {
  //     if (moment(cache[keys[i]].ttl).isBefore(moment())) {
  //       delete cache[keys[i]];
  //     }
  //   }
  //   window.sessionStorage.setItem(CACHE_NAME, JSON.stringify(cache));
  // } catch (e) {
  //   console.error(e);
  //   return null;
  // }
};

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
(() => {
  if (window.sessionStorage.getItem(CACHE_NAME) === null) {
    window.sessionStorage.setItem(CACHE_NAME, JSON.stringify({}));
  } else {
    try {
      JSON.parse(window.sessionStorage.getItem(CACHE_NAME));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      window.sessionStorage.setItem(CACHE_NAME, JSON.stringify({}));
    } finally {
      flushCache();
    }
  }
  setInterval(flushCache, 1000 * 60 * 10); // 10 minutes
})();

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
export const setCache = () => {
  // try {
  //   const cache = JSON.parse(window.sessionStorage.getItem(CACHE_NAME));
  //   cache[key] = {
  //     value,
  //     ttl: moment()
  //       .add(ttl, "minutes")
  //       .toDate()
  //   };
  //   window.sessionStorage.setItem(CACHE_NAME, JSON.stringify(cache));
  // } catch (e) {
  //   console.error(e);
  //   return null;
  // }
};

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
export const getCache = () => {
  // try {
  //   const cache = JSON.parse(window.sessionStorage.getItem(CACHE_NAME));
  //   if (cache[key]) {
  //     if (moment(cache[key].ttl).isAfter(moment())) {
  //       return cache[key].value;
  //     }
  //     delete cache[key];
  //     window.sessionStorage.setItem(CACHE_NAME, JSON.stringify(cache));
  //     return null;
  //   }
  // } catch (e) {
  //   console.error(e);
  //   return null;
  // }
};

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
export const deleteCache = () => {
  // try {
  //   const cache = JSON.parse(window.sessionStorage.getItem(CACHE_NAME));
  //   const keys = Object.keys(cache);
  //   for (let i of keys) {
  //     if (new RegExp(key).test(i)) {
  //       delete cache[i];
  //     }
  //   }
  //   window.sessionStorage.setItem(CACHE_NAME, JSON.stringify(cache));
  // } catch (e) {
  //   console.error(e);
  //   return null;
  // }
};

/**
 * @deprecated use InMemoryCache from shared/cache instead
 */
export const deleteAllCache = () => {
  try {
    window.sessionStorage.removeItem(CACHE_NAME);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};
